import { FormFieldsConfig } from '../../types';

export const defaultFieldsConfig: FormFieldsConfig = {
  place: {
    label: 'Dove cerchi casa?',
    ariaLabel: 'Campo per la ricerca geografica',
    placeholder: 'Inserisci città, provincia o quartiere',
    hidden: false,
  },
  price: {
    label: 'Qual è il tuo budget?',
    hidden: false,
  },
  size: {
    label: 'Hai preferenze sulla superficie?',
    hidden: false,
  },
  button: {
    label: 'Cerca immobili',
    ariaLabel: 'Invia il form per avviare la ricerca immobili',
  },
};
